import { UserRegistration } from "../../models/userRegistration";

export class RegisterUser {
  public static readonly type = "[Users] Register User";
  public constructor(public user: UserRegistration) {}
}
